import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import styled from 'styled-components';
import {
  StyledTable,
  StyledTitle,
  StyledTd,
} from './custom-styled-components/_MyCustomSC';
import { Select, Checkbox, Tooltip } from 'antd';
import { isEmpty } from '../../util/isEmpty';
import PickupDeliveryFactory from './PickupDeliveryFactory';
import ExistingFactoryDescForm from './ExistingFactoryDescForm';
import NewFactoryDescForm from './NewFactoryDescForm';
import CustomDropdownRender from '../common/CustomDropdownRender';
import { sortArrObjStr } from '../../util/sortArrObjStr';
import { chunkString } from '../../util/chunkString';
import PropTypes from 'prop-types';
import EcommerceAmazonDescForm from './EcommerceAmazonDescForm';
import { FORM_DELIVERY_ECOMMERCE_LEARN_MORE_URL } from '../../envVariables';
import AmazonBoxPallet from './AmazonBoxPallet';
import ExistingFactoryDropdown from './ExistingFactoryDropdown';

const { Option } = Select;

const StyledSelect = styled(Select)`
  width: 170px;
  color: #717585;
`;

// const StyledInput = styled(Input)`
//   width: 440px;
//   color: #717585;
// `;

// const EXISTING_FACTORY = 'existing factory';
// const NEW_FACTORY = 'new factory';

const PORT = 'port';

const OPTION_STRING_CHUNK_LENGTH = 23;

/**
 * @component
 * @category Form Page
 * @subcategory Delivery
 * @name DeliveryForm
 * @description delivery component
 * <br> <br>
 * **Example**
 * ```js
 *   <DeliveryForm/>
 * ```
 */
class DeliveryForm extends Component {
  state = {
    selectedCountry: '',
    selectedCity: '',
    showCheckboxCharge: true,
  };

  /**
   * @description when delivery origin location type dropdown is selected, it is invoked
   * <br> <br>
   * **onPortChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         |  string       |  `port` or `factory` or `ecommerce` or `amazon`|

   * Returns: Type: void
   */
  onPortChange = (value) => {
    if (value === 'port') {
      this.props.getRemoteDelievryData();
      // this.props.updateDeliveryData({
      //   // existingFactoryJson: {}, // comment this for getting init form data
      //   //selectedExistingFactory: '', //it was uncommneted earlier
      // });
      this.setState({
        showCheckboxCharge: true,
      });
      this.resetNewFactoryData();
      // this.updateExistingFactoryMissingPort('');
    } else if (value === 'factory') {
      this.props.updateDeliveryData({ country: '', city: '' });
      this.setState({ showCheckboxCharge: false });
    } else if (value === 'ecommerce') {
      this.props.getRemoteDeliveryEcommerceData();
    } else if (value === 'amazon') {
      this.props.getRemoteDeliveryAmazonData();
    }

    //reset ecommerce and amazon selected factory json to empty obj
    this.props.saveDeliveryEcommerceData({
      selectedEcommerceJson: {},
      factoryListArrIndex: null,
    });
    this.props.saveDeliveryAmazonData({
      selectedAmazonJson: {},
      factoryListArrIndex: null,
    });

    this.props.updatePickupDeliveryFactoryInfo({
      type: 'delivery',
      data: {
        isExistingFactorySelected: null,
        existingFactoryListArrIndex: null,
      },
    });
    this.props.updateDeliveryData({
      deliveryType: value,
      selectedExistingFactoryJson: '',
    });
    this.props.saveDeliveryAmazonData({
      boxSelection: undefined,
      palletSelection: undefined,
    });
  };

  /**
   * @description when  type `port` is selected, it is invoked when
   * either a country dropdown option or a city dropdown option is selected.
   * <br> <br>
   * **onSelectChange(value, type) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         |  string       |  selected value e.g. `Australia` for type `country`, `{"name":"Linz","id":26}` for type `city`|
   * | type          |  string       |  dropdown type e.g. `country`, `city` |

   * Returns: Type: void
   */
  onSelectChange = (value, type) => {
    if (type === 'country') {
      this.props.updateDeliveryData({ country: value });
    } else {
      const cityObj = JSON.parse(value);
      this.props.updateDeliveryData({ city: cityObj.name, id: cityObj.id });
    }
  };

  /**
   * @description when  an existing factory or "new factory" is selected,
   * it is invoked from [PickupDeliveryFactory]{@link PickupDeliveryFactorySet} component.
   * <br> <br>
   * **onFactoryDataChange(isExistingFactory, data) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | isExistingFactory             |  boolean       |  `true` - existing factory is selected, `false` - new factory is selected |
   * | data          |  number       |  selected existing factory array index e.g. `0`, `1`, it is `null` in case of new factory |

   * Returns: Type: void
   */
  onFactoryDataChange = (isExistingFactory, data) => {
    console.log(isExistingFactory)
    console.log(data)
    if (isExistingFactory) {
      this.resetNewFactoryData();
      this.props.updatePickupDeliveryFactoryInfo({
        type: 'delivery',
        data: {
          isExistingFactorySelected: true,
          existingFactoryListArrIndex: data.id, // here data is 0, 1, etc
        },
      });
    } else {
      this.props.updatePickupDeliveryFactoryInfo({
        type: 'delivery',
        data: {
          isExistingFactorySelected: false,
          existingFactoryListArrIndex: data, // here data is 'null'
        },
      });
      this.props.updateDeliveryData({
        selectedExistingFactoryJson: '',
      });
    }
    // this.updateExistingFactoryMissingPort('');
  };

  /**
   * @description when a port in new factory is selected, this is invoked
   * <br> <br>
   * **handleSelectExistingNewPort(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             |  string       |  selected port obj string in new factory |

   * Returns: Type: void
   */
  handleSelectExistingNewPort = (e) => {
    const { isExistingFactorySelected } = this.props;
    // console.log(e.key);
    if (isExistingFactorySelected) {
      // console.log('updateExistingFactoryMissingPort:', e.key);
      // this.updateExistingFactoryMissingPort(JSON.parse(e.key));
    } else {
      const obj = JSON.parse(e); //e is the selected port obj in new factory
      // const data = `${obj.name}, ${obj.country} `;
      // this.handleNewFactoryInfoChange([PORT], data);
      this.handleNewFactoryInfoChange([PORT], obj);
    }
  };

  /**
   * @description when new factory description form data changes, this is invoked
   * <br> <br>
   * **handleNewFactoryInfoChange(type, value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | type          | object or string or array      |  new factory description data e.g. `city`, `["port"]`, `busines_type` |
   * | value         | object or string       |  entered new factory description form value e.g. `delhi`, `{id: 122323, country: "Bangladesh", name:"Mongla"}` |

   * Returns: Type: void
   */
  handleNewFactoryInfoChange = (type, value) => {
    this.updateNewFactoryData({ [type]: value });
  };
  //update missing port in redux store for existing factory single item
  // updateExistingFactoryMissingPort = (port) => {
  //   // this.props.updatePickupDeliveryFactoryInfo({
  //   //   type: 'delivery',
  //   //   data: { existingMissingPort: port },
  //   // });
  //   this.props.updatePickupDeliveryExistingFactoryPort({
  //     type: 'delivery',
  //     data: { port },
  //   });
  // };

  /**
   * @description update new factory info in redux store
   * <br> <br>
   * **updateNewFactoryData(info) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | info          | object        |  entered new factory description form data |

   * Returns: Type: void
   */
  updateNewFactoryData = (info) => {
    const { newFactoryInfo } = this.props;
    this.props.updatePickupDeliveryFactoryInfo({
      type: 'delivery',
      data: {
        newFactory: { ...newFactoryInfo, ...info },
      },
    });
  };

  /**
   * @description when `port` or existing factory is selected, then new factory data is reset.
   * <br> <br>
   * **resetNewFactoryData() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  resetNewFactoryData = () => {
    const newFactoryInfo = {
      newFactory: {
        address: '',
        city: '',
        country: '',
        postal: '',
        name: '',
        email: '',
        port: {},
      },
    };
    this.props.updatePickupDeliveryFactoryInfo({
      type: 'delivery',
      data: {
        ...newFactoryInfo,
      },
    });
  };

  render() {
    const { showCheckboxCharge } = this.state;
    const { deliveryJson, country, deliveryType, isDeliveryChargeIncluded } =
      this.props.delivery;
    console.log(this.props.delivery)

    const showFactory = deliveryType === 'factory';
    const showPort = deliveryType === 'port';
    const showEcommerce = deliveryType === 'ecommerce';
    const showAmazon = deliveryType === 'amazon';
    //when user select port not factory , then country, city
    const selectedCity = this.props.delivery.city;
    const selectedCountry = country;

    // process json for port not factory
    let countries;
    let cities;

    let countriesSet = new Set();
    !isEmpty(deliveryJson) &&
      !isEmpty(deliveryJson.Ports) &&
      deliveryJson.Ports.map((port) => countriesSet.add(port.Country));
    countries = Array.from(countriesSet);
    countries = sortArrObjStr(countries);

    let citiesSet = new Set();
    !isEmpty(deliveryJson) &&
      !isEmpty(deliveryJson.Ports) &&
      deliveryJson.Ports.map(
        (port) =>
          port.Country === selectedCountry &&
          citiesSet.add({ name: port.Name, id: port.id })
      );
    cities = Array.from(citiesSet);
    cities = sortArrObjStr(cities, undefined, 'name');

    // for factory / business

    // for empty port object in a single factory jason dropdown menu
    //process json
    const { portsJSON, missingPort } = this.props;
    let tempCountriesSet = new Set();
    !isEmpty(portsJSON) &&
      !isEmpty(portsJSON.Ports) &&
      portsJSON.Ports.map((port) => tempCountriesSet.add(port.Country));

    let myCountries = Array.from(tempCountriesSet);

    //for existing factory
    const { existingFactoryJson, existingFactoryListArrIndex } = this.props;
    const { isExistingFactorySelected, selectedExistingFactoryJson } =
      this.props;

    const selectedFactoryJson = selectedExistingFactoryJson;

    const selectedFactoryInfo = selectedFactoryJson &&
      !isEmpty(selectedFactoryJson) && (
        <ExistingFactoryDescForm
          portsJSON={portsJSON || {}}
          myCountries={myCountries}
          selectedFactoryJson={selectedFactoryJson}
          // missingPort={missingPort}
          handleSelectExistingNewPort={this.handleSelectExistingNewPort}
          isPickupMode={false}
        />
      );

    //for new factory
    const { newFactoryInfo } = this.props;

    const enterNewFactoryInfo = !isExistingFactorySelected && (
      <NewFactoryDescForm
        portsJSON={portsJSON || {}}
        myCountries={myCountries}
        handleNewFactoryInfoChange={this.handleNewFactoryInfoChange}
        newFactoryInfo={newFactoryInfo}
        handleSelectExistingNewPort={this.handleSelectExistingNewPort}
        isPickupMode={false}
      />
    );

    const {
      showFormDeliveryEcommerce,
      formDeliveryEcommerceDescText,
      formDeliveryAmazonDescText,
      ecommerceJson,
      selectedEcommerceJson,
      ecommerceFactoryListArrIndex,
      showFormDeliveryAmazon,
      amazonJson,
      selectedAmazonJson,
      amazonFactoryListArrIndex,
    } = this.props;

    return (
      <>
        <StyledTable style={{ width: '641px', marginRight: '15px' }}>
          <tbody>
            <tr>
              <th style={{ paddingLeft: '15px', fontWeight: 600 }}>
                Deliver goods to
              </th>
            </tr>
            <tr>
              <StyledTd
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-around',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'flex-start',
                  }}
                  className="testR1"
                >
                  <span className="my-form-custom-select testO1">
                    <StyledTitle>Destination location type</StyledTitle>
                    <StyledSelect
                      placeholder="Select.."
                      onChange={this.onPortChange}
                      // className="my-select20"
                      value={deliveryType || undefined}
                    >
                      {/* port mode */}
                      <Option
                        key="port"
                        value="port"
                        label="Port(FOB)"
                        style={{ height: '85px' }}
                      >
                        <Tooltip
                          placement="right"
                          autoAdjustOverflow
                          title="Pickup at port warehouse, no trucking included"
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                            }}
                          >
                            <span style={{ color: '#333333' }}>Port</span>

                            {chunkString(
                              'Pickup at port warehouse, no trucking included',
                              OPTION_STRING_CHUNK_LENGTH
                            ).map((str, index) => (

                              <span
                                key={index}
                                className="option-desc"
                                style={{
                                  fontSize: '11px',
                                  color: '#8DABC4',
                                }}
                              >
                                {str}
                              </span>
                            ))}
                          </div>
                        </Tooltip>
                      </Option>

                      {/* factory mode */}
                      <Option
                        key="factory"
                        value="factory"
                        label="Factory"
                        style={{ height: '85px' }}
                      >
                        <Tooltip
                          placement="right"
                          autoAdjustOverflow
                          title="Industrial setting with loading dock"
                        >
                          <div
                            style = {{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                            }}
                          >
                            <span style={{ color: '#333333' }}>
                              Your Business / Delivery Location
                            </span>

                            {chunkString(
                              'Industrial setting with loading dock',
                              OPTION_STRING_CHUNK_LENGTH
                            ).map((str, index) => (
                              <span
                                key={index}
                                className="option-desc"
                                style={{
                                  fontSize: '11px',
                                  color: '#8DABC4',
                                }}
                              >
                                {str}
                              </span>
                            ))}
                          </div>
                        </Tooltip>
                      </Option>

                      {/*  Prime Freight E-Commerce mode */}
                      {/*{showFormDeliveryEcommerce && (*/}
                      {/*  <Option*/}
                      {/*    key="ecommerce"*/}
                      {/*    value="ecommerce"*/}
                      {/*    label="Prime Freight E-Commerce"*/}
                      {/*    style={{ height: 'auto' }}*/}
                      {/*  >*/}
                      {/*    <Tooltip*/}
                      {/*      placement="right"*/}
                      {/*      autoAdjustOverflow*/}
                      {/*      title={formDeliveryEcommerceDescText} //from env. var*/}
                      {/*    >*/}
                      {/*      <div*/}
                      {/*        style={{*/}
                      {/*          display: 'flex',*/}
                      {/*          flexDirection: 'column',*/}
                      {/*          width: '100%',*/}
                      {/*        }}*/}
                      {/*      >*/}
                      {/*        <span style={{ color: '#333333' }}>*/}
                      {/*          Prime Freight E-Commerce*/}
                      {/*        </span>*/}

                      {/*        {chunkString(*/}
                      {/*          formDeliveryEcommerceDescText,*/}
                      {/*          OPTION_STRING_CHUNK_LENGTH*/}
                      {/*        ).map((str, index) => (*/}
                      {/*          <span*/}
                      {/*            key={index}*/}
                      {/*            className="option-desc"*/}
                      {/*            style={{*/}
                      {/*              fontSize: '11px',*/}
                      {/*              color: '#8DABC4',*/}
                      {/*            }}*/}
                      {/*          >*/}
                      {/*            {str}*/}
                      {/*          </span>*/}
                      {/*        ))}*/}
                      {/*        /!* learn more link *!/*/}
                      {/*        <span*/}
                      {/*          className="option-desc"*/}
                      {/*          style={{*/}
                      {/*            fontSize: '11px',*/}
                      {/*            color: '#8DABC4',*/}
                      {/*          }}*/}
                      {/*        >*/}
                      {/*          <a*/}
                      {/*            href={FORM_DELIVERY_ECOMMERCE_LEARN_MORE_URL}*/}
                      {/*            target="_blank"*/}
                      {/*            rel="noopener noreferrer"*/}
                      {/*          >*/}
                      {/*            Learn more*/}
                      {/*          </a>*/}
                      {/*        </span>*/}
                      {/*      </div>*/}
                      {/*    </Tooltip>*/}
                      {/*  </Option>*/}
                      {/*)}*/}

                      {/*  Amazon Warehouse mode */}
                      {/*{showFormDeliveryAmazon && (*/}
                      {/*  <Option*/}
                      {/*    key="amazon"*/}
                      {/*    value="amazon"*/}
                      {/*    label="Amazon Warehouse"*/}
                      {/*    style={{ height: 'auto' }}*/}
                      {/*  >*/}
                      {/*    <Tooltip*/}
                      {/*      placement="right"*/}
                      {/*      autoAdjustOverflow*/}
                      {/*      title={formDeliveryAmazonDescText} //from env. var*/}
                      {/*    >*/}
                      {/*      <div*/}
                      {/*        style={{*/}
                      {/*          display: 'flex',*/}
                      {/*          flexDirection: 'column',*/}
                      {/*          width: '100%',*/}
                      {/*        }}*/}
                      {/*      >*/}
                      {/*        <span style={{ color: '#333333' }}>*/}
                      {/*          Amazon Warehouse*/}
                      {/*        </span>*/}

                      {/*        {chunkString(*/}
                      {/*          formDeliveryAmazonDescText,*/}
                      {/*          OPTION_STRING_CHUNK_LENGTH*/}
                      {/*        ).map((str, index) => (*/}
                      {/*          <span*/}
                      {/*            key={index}*/}
                      {/*            className="option-desc"*/}
                      {/*            style={{*/}
                      {/*              fontSize: '11px',*/}
                      {/*              color: '#8DABC4',*/}
                      {/*            }}*/}
                      {/*          >*/}
                      {/*            {str}*/}
                      {/*          </span>*/}
                      {/*        ))}*/}
                      {/*      </div>*/}
                      {/*    </Tooltip>*/}
                      {/*  </Option>*/}
                      {/*)}*/}
                    </StyledSelect>
                  </span>
                  {/* factory */}
                  {showFactory && (
                    <PickupDeliveryFactory
                      onFactoryDataChange={this.onFactoryDataChange}
                      isPickupFactory={false}
                      mode={'delivery'}
                    />
                  )}
                  {/* show ecommerce or show amazon existing factory dropdown */}
                  {(showEcommerce || showAmazon) && (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'start',
                        alignItems: 'flex-start',
                      }}
                      className="testBla1"
                    >
                      <span className="testO1" style={{ width: '100%' }}></span>
                      <span
                        style={{
                          width: '100%',
                        }}
                        className="testR1"
                      >
                        {/* ecommerce existing factory dropdown */}

                        {showEcommerce && (
                          <ExistingFactoryDropdown
                            data={ecommerceJson}
                            onExistingFactorySelectChange={(id) => {
                              // console.log(id);
                              this.props.saveDeliveryEcommerceData({
                                selectedEcommerceJson:
                                  ecommerceJson['factory_list'][id],
                                factoryListArrIndex: id,
                              });
                            }}
                            existingFactoryListArrIndex={
                              ecommerceFactoryListArrIndex
                            }
                          />
                        )}

                        {/* amazon existing factory dropdown */}
                        {showAmazon && (
                          <ExistingFactoryDropdown
                            data={amazonJson}
                            onExistingFactorySelectChange={(id) => {
                              // console.log(id);

                              this.props.saveDeliveryAmazonData({
                                selectedAmazonJson:
                                  amazonJson['factory_list'][id],
                                factoryListArrIndex: id,
                              });
                            }}
                            existingFactoryListArrIndex={
                              amazonFactoryListArrIndex
                            }
                          />
                        )}
                      </span>
                      <span className="testO1" style={{ width: '100%' }}></span>
                    </div>
                  )}

                  {/* port */}
                  {(showPort || !deliveryType) && (
                    // port country, city selection
                    <span
                      style={{
                        flex: '1',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        alignItems: 'flex-start',
                      }}
                      className="testO1"
                    >
                      <span className="testO1" style={{ width: '100%' }}></span>
                      <span>
                        <StyledTitle>Destination country</StyledTitle>

                        <StyledSelect
                          placeholder="Select country"
                          onChange={(value) =>
                            this.onSelectChange(value, 'country')
                          }
                          value={selectedCountry || undefined}
                          dropdownRender={(menu) => (
                            <div>
                              {deliveryType && !isEmpty(deliveryJson) ? (
                                menu
                              ) : (
                                <CustomDropdownRender
                                  text={
                                    !deliveryType &&
                                    'select location type first'
                                  }
                                  showSpin={!!deliveryType}
                                />
                              )}
                            </div>
                          )}
                        >
                          {myCountries.map((country, index) => (
                            <Option
                              value={country}
                              key={`${country}, ${index}`}
                            >
                              {country}
                            </Option>
                          ))}
                        </StyledSelect>
                      </span>
                      <span className="testO1" style={{ width: '100%' }}></span>
                      <span>
                        <StyledTitle>City </StyledTitle>

                        <StyledSelect
                          placeholder="Select city"
                          // defaultValue="china"
                          onChange={(value) =>
                            this.onSelectChange(value, 'city')
                          }
                          value={selectedCity || undefined}
                          dropdownRender={(menu) => (
                            <div>
                              {cities.length !== 0 ? (
                                menu
                              ) : (
                                <CustomDropdownRender text="select country first" />
                              )}
                            </div>
                          )}
                        >
                          {cities.map((port, index) => (
                            <Option
                              value={JSON.stringify(port)}
                              key={`${port.name}, ${index}`}
                            >
                              {port.name}
                            </Option>
                          ))}
                        </StyledSelect>
                      </span>
                      <span className="testO1" style={{ width: '100%' }}></span>
                    </span>
                  )}
                </div>

                {/* existing factory */}
                {existingFactoryListArrIndex !== null && selectedFactoryInfo}
                {/* new factory */}
                {isExistingFactorySelected !== null &&
                  isExistingFactorySelected === false &&
                  enterNewFactoryInfo}

                {/* ecommerce */}
                {showEcommerce &&
                  selectedEcommerceJson &&
                  !isEmpty(selectedEcommerceJson) && (
                    <div style={{ width: '100%' }}>
                      <EcommerceAmazonDescForm
                        descJson={selectedEcommerceJson}
                        // loadJson={this.props.getRemoteDeliveryEcommerceData}
                        // loadJson={() => {}}

                        isPickupMode={false}
                      />
                    </div>
                  )}

                {/* amazon */}
                {showAmazon &&
                  selectedAmazonJson &&
                  !isEmpty(selectedAmazonJson) && (
                    <div style={{ width: '100%' }}>
                      <EcommerceAmazonDescForm
                        descJson={selectedAmazonJson}
                        // loadJson={this.props.getRemoteDeliveryAmazonData}
                        // loadJson={() => {}}

                        isPickupMode={false}
                      />
                      {/* amazon mode box/pallet UI */}
                      <AmazonBoxPallet />
                    </div>
                  )}

                {/* bottom checkbox */}
                {showCheckboxCharge && (
                  <div
                    style={{
                      paddingTop: '4px',
                      fontSize: '13px',
                    }}
                    className="testR1"
                  >
                    <Checkbox
                      style={{ marginRight: '4px' }}
                      checked={
                        isDeliveryChargeIncluded
                          ? isDeliveryChargeIncluded
                          : false
                      }
                      onChange={(e) => {
                        this.props.updateDeliveryData({
                          isDeliveryChargeIncluded: e.target.checked,
                        });
                      }}
                    />
                    <span style={{ color: '#373848' }}>
                      Destination Charges included
                    </span>
                  </div>
                )}
              </StyledTd>
            </tr>
          </tbody>
        </StyledTable>
      </>
    );
  }
}

DeliveryForm.propTypes = {
  /**
   * delivery section data
   */
  delivery: PropTypes.object,
  /**
   * delivery existing factory json
   */
  existingFactoryJson: PropTypes.object,
  /**
   * destination ports json on search page
   */

  portsJSON: PropTypes.object,

  /**
   *  delivery new factory data
   */
  newFactoryInfo: PropTypes.object,
  /**
   * delivery factory info
   */
  deliveryFactoryInfo: PropTypes.object,
  /**
   * array index (starts from zero) of selected existing factory in the list of factories
   * it also accepts `null`
   */
  existingFactoryListArrIndex: PropTypes.number,
  /**
   * whether existing factory is selected. it also accepts `null`
   */
  isExistingFactorySelected: PropTypes.bool,
  /**
   * selected Existing Factory for delivery on factory mode
   */
  selectedExistingFactoryJson: PropTypes.object,

  /**
   * Whether to show e-commerce option in delivery destination location type on form page.
   */
  showFormDeliveryEcommerce: PropTypes.bool,

  /**
   * Delivery destination location type, e-commerce description text on form page.
   */
  formDeliveryEcommerceDescText: PropTypes.string,

  /**
   * Delivery destination location type, amazon warehouse description text on form page.
   */
  formDeliveryAmazonDescText: PropTypes.string,

  /**
   * e-commerce json data
   */
  ecommerceJson: PropTypes.object,

  /**
   * selected e-commerce factory
   */
  selectedEcommerceJson: PropTypes.object,

  /**
   * array index (starts from zero) of selected e-commerce factory in the list of factories
   * it also accepts `null`
   */
  ecommerceFactoryListArrIndex: PropTypes.object,

  /**
   * Whether to show amazon option in delivery destination location type on form page.
   */
  showFormDeliveryAmazon: PropTypes.bool,

  /**
   * amazon json data
   */
  amazonJson: PropTypes.object,

  /**
   * selected amazon factory
   */
  selectedAmazonJson: PropTypes.object,

  /**
   *  array index (starts from zero) of selected amazon factory in the list of factories
   * it also accepts `null`
   */
  amazonFactoryListArrIndex: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    delivery: state.form.delivery,
    existingFactoryJson: state.form.delivery.existingFactoryJson,
    portsJSON: state.route.destinationPortJSON,
    // portsJSON: state.cache.searchDestinationPortsData.data,
    // missingPort: state.form.factoryInfo.delivery.existingMissingPort,
    newFactoryInfo: state.form.factoryInfo.delivery.newFactory,
    deliveryFactoryInfo: state.form.factoryInfo.delivery,
    existingFactoryListArrIndex:
      state.form.factoryInfo.delivery.existingFactoryListArrIndex,

    isExistingFactorySelected:
      state.form.factoryInfo.delivery.isExistingFactorySelected,

    selectedExistingFactoryJson:
      state.form.delivery.selectedExistingFactoryJson,

    showFormDeliveryEcommerce: state.code_config.showFormDeliveryEcommerce,

    formDeliveryEcommerceDescText:
      state.code_config.formDeliveryEcommerceDescText,

    formDeliveryAmazonDescText: state.code_config.formDeliveryAmazonDescText,

    ecommerceJson: state.form.delivery.ecommerceMode.ecommerceJson,
    selectedEcommerceJson:
      state.form.delivery.ecommerceMode.selectedEcommerceJson,

    ecommerceFactoryListArrIndex:
      state.form.delivery.ecommerceMode.factoryListArrIndex,

    showFormDeliveryAmazon: state.code_config.showFormDeliveryAmazon,
    amazonJson: state.form.delivery.amazonMode.amazonJson,
    selectedAmazonJson: state.form.delivery.amazonMode.selectedAmazonJson,

    amazonFactoryListArrIndex:
      state.form.delivery.amazonMode.factoryListArrIndex,
  };
};

export default connect(mapStateToProps, actions)(DeliveryForm);
